import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/style.css";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "vue3-easy-data-table/dist/style.css";
import "./axios/axios.js";
import ArgonDashboard from "./argon-dashboard";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
